import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { river } from "../../../hooks/use-map-theme-styles";

export const flexFormStyles: any = {
	proceedWithoutReviewCheckbox: {
		color: "#212121",
		fontSize: 14,
	},
};

export default makeStyles((theme: Theme) =>
	createStyles({
		pageHeaderText: {
			fontWeight: 600,
			margin: theme.spacing(2, 0, 3, 0),
		},
		pageHeaderTextWithoutIndent: {
			fontWeight: 600,
			lineHeight: 1,
		},
		column2: {
			width: "48%",
			marginRight: "2%",
		},
		column3: {
			minWidth: "30%",
			marginRight: "3%",
		},
		column5: {
			minWidth: "15%",
		},
		listHeader: {
			color: theme.palette.enabledHeader.main,
			fontSize: "12px",
			marginLeft: "15px",
		},
		listItem: {
			fontWeight: 600,
		},
		section: {
			marginBottom: theme.spacing(5),
		},
		sectionDetails: {
			backgroundColor: river,
			padding: theme.spacing(0, 2),
		},
		externalSummary: {
			backgroundColor: theme.palette.background.paper,
		},
		columnNarrowed: {
			width: "20%",
			marginRight: "10%",
		},
		columnExtended: {
			width: "70%",
		},
		caseGroupBracketContainer: {
			width: "15px",
			display: "flex",
			justifyContent: "center",
		},
		caseGroupBracket: {
			borderBottomLeftRadius: "5px",
			borderTopLeftRadius: "5px",
			borderStyle: "solid",
			borderColor: "#5e6e7d",
			borderWidth: "2px",
			borderRightStyle: "none",
			display: "flex",
			flexDirection: "column",
			width: "10px",
			height: "inherit",
			margin: "15px 0 15px 8px",
		},
		row: {
			margin: theme.spacing(5, 0),
		},
		colShort: {
			width: "12%",
		},
		colMedium: {
			width: "24%",
		},
		colLong: {
			width: "48%",
		},
		colExtraLong: {
			width: "60%",
		},
		page: {
			padding: theme.spacing(3, 2),
			borderRadius: "4px",
			boxShadow: "none",
		},
		bodyItemHeaderTop: {
			borderBottom: `1px solid ${theme.palette.background.default}`,
			display: "flex",
			justifyContent: "space-between",
			width: "100%",
			borderRadius: "4px 4px 0 0",
			boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.08)",
		},
		nestedContent: {
			marginLeft: theme.spacing(2),
		},
		nestedContent2: {
			marginLeft: theme.spacing(4),
		},
		disclaimer: {
			padding: theme.spacing(2),
			backgroundColor: theme.palette.background.default,
		},
		headlessSection: {
			marginTop: theme.spacing(7),
		},
		fullWidth: {
			width: "100%",
		},
		buttonBar: {
			position: "absolute",
			top: "auto",
			bottom: 0,
			left: theme.spacing(2),
			width: "100%",
			height: theme.spacing(10),
		},
		contentDrawer: {
			position: "relative",
			width: "50%",
			margin: "-24px 0",
			padding: theme.spacing(2),
		},
		tableFull: {
			width: "100%",
			"& .MuiPaper-root": {
				borderRadius: theme.spacing(2),
			},
		},
		tableShort: {
			width: "50%",
			"& .MuiPaper-root": {
				borderRadius: theme.spacing(2, 0, 0, 2),
			},
		},
		caseSelectionHeader: {
			backgroundColor: theme.palette.inputTableDivider.main,
			padding: "16px 44px",
		},
		paper: {
			borderRadius: "4px",
			minHeight: "75%",
		},
		mt1: {
			marginTop: theme.spacing(1),
		},
		mt2: {
			marginTop: theme.spacing(2),
		},
		icon: {
			fontSize: "13px",
		},
		disabledInput: {
			backgroundColor: theme.palette.background.default,
		},
		disableInputOutline: {
			borderWidth: "0px",
		},
		input: {
			marginTop: theme.spacing(1),
			minWidth: "200px",
		},
		br10: {
			borderRadius: "4px",
		},
		divider: {
			flexGrow: 1,
			borderTop: `3px solid ${theme.palette.grey[300]}`,
			marginLeft: theme.spacing(2),
			marginRight: theme.spacing(2),
		},
		w10: {
			width: "10%",
		},
		w20: {
			width: "20%",
		},
		w30: {
			width: "30%",
		},
		w40: {
			width: "40%",
		},
		w50: {
			width: "50%",
		},
		w60: {
			width: "60%",
		},
		w70: {
			width: "70%",
		},
		w80: {
			width: "80%",
		},
		w90: {
			width: "90%",
		},
		w100: {
			width: "100%",
		},
		subHeader: {
			backgroundColor: theme.palette.background.default,
			width: "100%",
		},
		prescriptionContent: {
			paddingLeft: theme.spacing(3),
			padding: theme.spacing(2),
		},
		mw200: {
			minWidth: "200px",
		},
		ml1: {
			marginLeft: theme.spacing(1),
		},
		formButton: {
			color: "#37679D",
			textTransform: "uppercase",
		},
		dialogPaper: {
			borderRadius: theme.spacing(2),
			padding: theme.spacing(2),
			minWidth: "584px",
			minHeight: "285px",
		},
		createdMark: {
			margin: theme.spacing(7, 0),
			textAlign: "center",
			color: "#007D23",
			size: theme.spacing(7),
		},
		largeIcon: {
			width: theme.spacing(10),
			height: theme.spacing(10),
		},
		mb2: {
			marginBottom: theme.spacing(2),
		},
		mb5: {
			marginBottom: theme.spacing(5),
		},
		shrinkedLabelPositioning: {
			position: "absolute",
			left: 0,
			top: "-10px",
		},
		readOnlyControlContent: {
			marginBottom: "18px",
			fontSize: "16px",
		},
		ow: {
			overflowWrap: "break-word",
		},
		dialogWindow: {
			position: "relative",
			display: "flex",
			flexDirection: "column",
			alignItems: "flex-end",
			padding: "80px",
			paddingBottom: 0,
		},
		dialogClose: {
			position: "absolute",
			top: 7,
			right: 7,
			color: "#5e6e7d",
		},
		dialogButtons: {
			padding: "24px 0",
		},
		cropMessage: {
			position: "relative",
			bottom: 25,
			alignSelf: "start",
			fontSize: 18,
			fontWeight: 600,
			lineHeight: "1.19",
		},
		uploadContainer: {
			position: "relative",
			width: 600,
			height: 420,
			borderRadius: "7px",
			backgroundColor: theme.palette.inputTableDivider.main,
			display: "flex",
			flexDirection: "column",
			justifyContent: "center",
			alignItems: "center",
			flexGrow: 1,
			backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='7' ry='7' stroke='%23CDDCDCFF' strokeWidth='3' stroke-dasharray='7%2c15' strokeDashoffset='0' strokeLinecap='square'/%3e%3c/svg%3e")`,
		},
		cropContainer: {
			position: "absolute",
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			"& .reactEasyCrop_CropArea ": {
				color: "rgba(28, 49, 69, 0.4)",
			},
			"& .reactEasyCrop_CropAreaRound": {
				borderImageOutset: 3,
				borderImageSlice: "0 0 0 fill",
				borderImageSource: `url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzQyIiBoZWlnaHQ9IjM0MiIgdmlld0JveD0iMCAwIDM0MiAzNDIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNNTcuMjIgMjk3LjMxMkMyMi43IDI2Ni4xOTcgMSAyMjEuMTMyIDEgMTcxIDEgNzcuMTEyIDc3LjExMiAxIDE3MSAxczE3MCA3Ni4xMTIgMTcwIDE3MC03Ni4xMTIgMTcwLTE3MCAxNzBjLTM0LjIxNSAwLTY2LjA2OS0xMC4xMDgtOTIuNzM5LTI3LjUiIHN0cm9rZT0iI0NERENEQyIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1kYXNoYXJyYXk9IjggOCIvPgogICAgPHBhdGggZD0iTTc4IDMxMnYtMkg2NHYtMTJoMmwtMy0zLTMgM2gydjJoLTR2Mmg0djhjMCAxLjEuOSAyIDIgMmg4djJoLTJsMyAzIDMtM2gtMnYtMmg0em0tMTItMTBoNnY2aDJ2LTZjMC0xLjEtLjktMi0yLTJoLTZ2MnoiIGZpbGw9IiNDRERDREMiLz4KPC9zdmc+Cg==")`,
			},
		},
		cropControls: {
			position: "absolute",
			bottom: 0,
			left: "50%",
			width: "50%",
			transform: "translateX(-50%)",
			height: 46,
			display: "flex",
			aligItems: "center",
		},
		slider: {
			padding: "22px 0",
			color: "#fff !important",
			"& .MuiSlider-thumb": {
				height: 16,
				width: 16,
			},
			"& .MuiSlider-track, & .MuiSlider-rail": {
				height: 6,
				borderRadius: 7,
			},
			"& .MuiSlider-rail": {
				opacity: "20%",
			},
		},
		userAvatar: {
			height: "80px",
			width: "80px",
			backgroundColor: "#fef4dc",
			border: "1px solid #d3b279",
			cursor: "pointer",
		},
		userAvatarBox: {
			gap: 20,
			alignItems: "center",
		},
		userAvatarClickArea: {
			position: "relative",
			cursor: "pointer",
			borderRadius: "50%",
		},
		userFullName: {
			color: "#212121",
			fontWeight: 600,
		},
		addAPhotoIcon: {
			position: "absolute",
			bottom: 0,
			right: 0,
			backgroundColor: "#367bf5",
			borderRadius: "50%",
			color: "white",
			padding: 4,
		},
		uploadText: { color: "#367bf5", fontSize: 14, fontWeight: 600 },
	})
);
